import React, { useState, useEffect } from "react";
import Loader from "../loader/loader"; 
import { Mensaje } from "../Message/message";
import { ToastContainer } from "react-toastify";

import 'react-tabs/style/react-tabs.css'; 
import { Menu,Dash } from "../menu";
import "./calcular_almacenaje.css";
import { URL_CALC, GETCALCSUMARYS,SEARCH_CONTAINER } from "../paths";
import { fetchData } from "../../hooks/fetch/const_fetch";
import 'react-datalist-input/dist/styles.css';
 import { validSesion } from "../datainfo/dto";
import Detalle_Calcular_Almacenaje from "./detalle_calculo_almacenaje";
import CerrarSesion from "../datainfo/del_dto";
  
const Calcular_Almacenaje=()=>{
 
    const [contenedor,setContenedor] = useState("");
    const [strreferencia,setStrReferencia] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    
    const [plazodiaslibres,setPlazoDiasLibres] = useState(0);
    const [fechaalmacenaje,setFechaAlmacenaje] = useState("01/01/1999");
    
    const [buqueviaje,setBuqueViaje] = useState("");
    const [esimo,setEsImo] = useState(false);
    const [sobredimension,setSobreDimension] = useState(false);
    const [lngUniversalId,setLngUniversalId]=useState("");
    const [decNetweight,setDecNetweight]=useState(0);
    const [librehasta,setLibreHasta] = useState("");
    const [moneda,setMoneda] = useState(1);

    const [validiamoneda,setValidaMoneda] = useState(""); 
    const [validacontenedor,setValidaContenedor] = useState(""); 
    const [validalibrehasta,setValidaLibreHasta] = useState("");
    
    const [strbl,setStrBl] = useState("");
    const [validabl,setValidaBl] = useState("");
    
    const [intIsAttached,setIntIsAttached] = useState(0);
    const [intIsFull,setIntIsFull] = useState(0);

    const [tipoarchivo,setTipoArchivo] = useState([]);

    const [validareferencia,setValidaReferencia] = useState("");
    
    const d = new Date();
    
    const [intTraffic,setIntTraffic] = useState(0);

    const [calcularhasta,setCalcularHasta] = useState("");
    const [validacalcularhasta,setValidaCalcularHasta] = useState("");

    const [tipostraficos,setTipoTraficos] = useState([]);

    const [calcsumarys,setCalcSumarys] = useState([]);

    
    
    /*useEffect(()=>{
        if(!validSesion()){
            window.location.assign('/login');
            return;
        }
    },[]);*/
    if(!(validSesion())){ 
        CerrarSesion();
        window.location.assign('/login');
        return;
    } 
    const handleBL = (strref) => {
        if(strref.trim().length > 5 && strref.trim().length <= 45){ 
            setStrBl(strref.toUpperCase());
            setValidaBl(" is-valid ")
        }else{ 
            setStrBl(strref.toUpperCase());
            setValidaBl(" is-invalid ")
        }
    }

    const handleReferencia=(strref)=>{
        if(strref.trim().length > 5 && strref.trim().length <= 45){ 
            setStrReferencia(strref.toUpperCase());
            setValidaReferencia(" is-valid ")
        }else{ 
            setStrReferencia(strref.toUpperCase());
            setValidaReferencia(" is-invalid ")
        }
    }
    
    const handleContainer = (strref) => {
        Limpiar_Campos();
        if( strref.trim().length > 10 &&  strref.trim().length <= 13){
            setContenedor(strref.toUpperCase());
            setValidaContenedor(" is-valid ");
            //Consultar_Contenedor(true);
        }else{ 
            setContenedor(strref.toUpperCase());
            setValidaContenedor(" is-invalid ");
        }
    }
 
    const Limpiar_Campos =() =>{
        setBuqueViaje("");
        setMoneda(1);
        setValidaMoneda("");
        setCalcularHasta(((d.getFullYear())+"-"+((d.getMonth())<10?("0"+(d.getMonth()+1)):d.getMonth()+1)+"-"+(d.getDate())));
        //setCalcularHasta(((d.getDate())+"/"+(d.getMonth()<10?("0"+(d.getMonth()+1)):d.getMonth()+1)+"/"+ (d.getFullYear())));
        setValidaCalcularHasta("");

        setStrBl("")
        setLibreHasta("")
        setBuqueViaje("");
  

        setLngUniversalId("");
        setDecNetweight(0);
        setEsImo(false);
        setSobreDimension(false);
        setValidaLibreHasta("");  

        setCalcSumarys([]);
    }

    const Consultar_Contenedor = async(mostrar_cortinilla=true) => {
        try {  
            Limpiar_Campos();
            let valida=true;
            if(contenedor.trim().length===11 ){
                setValidaContenedor(" is-valid ");
            }else{
                setValidaContenedor(" is-invalid ");
                valida=false;
            }
            
            if(strreferencia.trim().length >= 6 && strreferencia.trim() !== "" ){
                setValidaReferencia(" is-valid ");
            }else{
                setValidaReferencia(" is-invalid ");
                valida=false;
            }
            if(!valida){ 
                return;
            }else{
                if(mostrar_cortinilla){
                    setIsLoading(true); 
                }
                const url = URL_CALC+SEARCH_CONTAINER; 
                const params = {
                    "strContainer" : contenedor, 
                    "strBL" :""
                }

                var myHeaders = new Headers();
                console.log("------- request consultar contenedor --------");
                   console.log(params);
                console.log("---------------");
                const resultado =  await fetchData(url, 'POST', myHeaders,params,60000); 
                console.log(resultado )
                if(resultado.code === 0){ 
                    console.log("-------request consultar contenedor--------");
                       console.log(resultado);
                    console.log("---------------");
                    setBuqueViaje(resultado.rows[0].ContainerData.strVesselVoyage);
                    setLibreHasta(resultado.rows[0].ContainerData.strDtmFreeUntil);
                    setEsImo(resultado.rows[0].ContainerData.intIsIMO);
                    setSobreDimension(resultado.rows[0].ContainerData.intIsOverDim);
                    setLngUniversalId(resultado.rows[0].ContainerData.lngUniversalId);
                    setStrBl(resultado.rows[0].ContainerData.strBL !== null ? resultado.rows[0].ContainerData.strBL:"");
                    setDecNetweight(resultado.rows[0].ContainerData.decNetweight)
                    

                    //const fecha_actual = (( (d.getFullYear()) +"-"+ ((d.getMonth()+1)<10?("0"+(d.getMonth()+1)):d.getMonth()+1) +"-"+ (d.getDate()<10?'0'+d.getDate():d.getDate())));
                    
                   /* let fecha_actual = "";
                    if(librehasta!==""){
                        let fecha = librehasta.replaceAll("-","/");
                        const date = new Date(fecha);
                        date.setDate( date.getDate() + 1 );
                        //alert(((date.getFullYear())+"-"+((date.getMonth()+1) < 10 ?("0"+(date.getMonth()+1)):date.getMonth()+1)+"-"+(date.getDate())));
                        fecha_actual = (((date.getFullYear())+"-"+((date.getMonth()+1) < 10 ?("0"+(date.getMonth()+1)):date.getMonth()+1)+"-"+(date.getDate())));
                        //setFechaHasta(((date.getDate()) +"-"+((date.getMonth()+1) < 10 ?("0"+(date.getMonth()+1)):date.getMonth()+1)+"-"+ (date.getFullYear())));
                         
                    }else{
                        const d = new Date();
                        d.setDate( d.getDate() + 1 );
                        // alert(((d.getFullYear())+"-"+((d.getMonth()+1) < 10 ?("0"+(d.getMonth()+1)):d.getMonth()+1)+"-"+(d.getDate())));
                        fecha_actual = (((d.getFullYear())+"-"+((d.getMonth()+1) < 10 ?("0"+(d.getMonth()+1)):d.getMonth()+1)+"-"+(d.getDate())));
                         
                    } */
                    
                    //alert(fecha_actual)
                    //setCalcularHasta(fecha_actual)
 
                    setPlazoDiasLibres(resultado.rows[0].ContainerData.intQtyFreeDays);
                    setFechaAlmacenaje(resultado.rows[0].ContainerData.strExpirationFreeDays? resultado.rows[0].ContainerData.strExpirationFreeDays:"");

                    setIntIsAttached(resultado.rows[0].ContainerData.intIsAttached);
                    setIntIsFull(resultado.rows[0].ContainerData.intIsFull);
                    
                    resultado.rows[0].ListFiscalMovement.forEach((item)=>{
                        if(item.strFiscalMov === "IMPO" || item.strFiscalMov === "EXPO"){
                            setIntTraffic(item.intFiscalMovId);
                        }
                    })
                    setTipoTraficos(resultado.rows[0].ListFiscalMovement);
                    GetCalcSumarys(resultado.rows[0].ContainerData.lngUniversalId,false);
                }else if(resultado.code <= -2){
                    Mensaje(resultado.msg, "warning","top-center",4000); 
                }
                else{
                    Mensaje(resultado.msg, "warning","top-center",4000);
                }
                setIsLoading(false); 
            } 
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error ,"error","top-center");
        }
    }
 
    const GetCalcSumarys = async(_lngUniversalId, mostrar_cortinilla=true) => {
        try {  
            
            if( _lngUniversalId !== "" && parseInt(_lngUniversalId) <= 0 ){
                Mensaje("El contenedor no acuenta con identificador universal.","warning","top-center",3500);
                return;
            }else{
                if(mostrar_cortinilla){
                    setIsLoading(true); 
                }
                const url = URL_CALC+GETCALCSUMARYS; 
                const params = {
                    "lng_Univ" : _lngUniversalId,
                }

                var myHeaders = new Headers();
                  console.log("------- request consultar GetCalcSumarys --------");
                      console.log(params);
                  console.log("---------------");
                const resultado =  await fetchData(url, 'POST', myHeaders,params,6000); 
                if(resultado.code === 0){ 
                    console.log("-------request consultar GetCalcSumarys--------");
                        console.log(resultado);
                    console.log("---------------");
                    setCalcSumarys(resultado.rows); 
                }else if(resultado.code <= -2){
                    Mensaje(resultado.msg, "warning","top-center",4000); 
                }else{
                    Mensaje(resultado.msg, "info","top-center",4000); 
                }
                setIsLoading(false); 
            } 
        }catch (error) {
            Mensaje("Error al hacer la solicitud, ERROR: "+error ,"error","top-center");
        }
    }
    
    return(
    <div className="main">
        <Menu /> 
        {isLoading?<Loader />:<></>} 
        <ToastContainer style={{width:'500px'}}/>
        <Dash>
            <div className="container-fluid">
                <p className="h5" >CÁLCULO DE ALMACENAJE</p>
                <hr className="m-0" />
                <div className="row py-2">
                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 ">
                        <label className="mx-0 px-0" htmlFor="ref">REFERENCIA:</label>
                        <input id="bl" type="text" autoComplete={"off"} className={`form-control form-control-sm ${validareferencia}`} maxLength={45} value={strreferencia} onChange={(evt)=>{handleReferencia(evt.target.value)}} />
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 ">
                        <label className="mx-0 px-0" htmlFor="ref">BL: </label>
                        <input id="contenedor" type="text" autoComplete={"off"} className={`form-control form-control-sm ${validabl}`} maxLength={50} value={strbl} onChange={(evt)=>{handleBL(evt.target.value)}} />
                    </div>
                    
                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 ">
                        <label className="mx-0 px-0" htmlFor="ref">NÚMERO DE CONTENEDOR:</label>
                        <input id="contenedor" type="text" autoComplete={"off"} className={`form-control form-control-sm ${validacontenedor}`} maxLength={11} value={contenedor} onChange={(evt)=>{handleContainer(evt.target.value)}} />
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 ">
                        <label className="mx-0 px-0" htmlFor="ref">LIBRE HASTA:</label>
                        <input id="librehasta" type="text"  disabled className={`form-control form-control-sm  ${validalibrehasta}`}  value={librehasta}  />
                    </div>
                </div>    
                <div className="row ">
                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
                        <button className="btn text-bg-success " onClick={Consultar_Contenedor}>CONSULTAR CONTENEDOR</button>
                    </div> 
                </div>
                <div className="row"> 
                    
                    {buqueviaje !== ""? 
                        <Detalle_Calcular_Almacenaje 
                            contenedor={contenedor} 
                            calcularhasta={calcularhasta} 
                            setCalcularHasta={setCalcularHasta} 
                            
                            librehasta={librehasta}
                            
                            setLibreHasta={setLibreHasta}
                            validacalcularhasta={validacalcularhasta}
                            setValidaCalcularHasta={setValidaCalcularHasta}
                            strbl={strbl}
                            moneda={moneda}
                            setMoneda={setMoneda}
                            
                            plazodiaslibres={plazodiaslibres}
                            fechaalmacenaje={fechaalmacenaje}

                            strreferencia={strreferencia}
                            setStrReferencia={setStrReferencia}
                            intIsAttached={intIsAttached}
                            intIsFull={intIsFull}

                            setValidaReferencia={setValidaReferencia}
                            setValidaContenedor={setValidaContenedor}
                            setValidaBl={setValidaBl}

                            setContenedor={setContenedor}
                            setStrBl={setStrBl}
                            setTipoArchivo={setTipoArchivo}
                            tipostraficos={tipostraficos}

                            calcsumarys={calcsumarys}
                            GetCalcSumarys={GetCalcSumarys}
                            validiamoneda={validiamoneda}
                            setValidaMoneda={setValidaMoneda}

                            intTraffic={intTraffic}
                            setIntTraffic={setIntTraffic}
                            
                            Limpiar_Campos={Limpiar_Campos}

                            decNetweight={decNetweight} 
                            setIsLoading={setIsLoading} 
                            lngUniversalId={lngUniversalId}   
                            buqueviaje={buqueviaje} 
                            esimo={esimo} 
                            setEsImo={setEsImo}
                            sobredimension={sobredimension}
                            setSobreDimension={setSobreDimension} 
                            
                        />
                        :<></>
                    }
                     
                </div>
                <div className="row"></div>
            </div>
        </Dash>
    </div>
    ) 
}

export default Calcular_Almacenaje;